module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "活动标题"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "maxlength": 50,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.title),
      callback: function($$v) {
        _vm.$set(_vm.form, "title", $$v)
      },
      expression: "form.title"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动内容"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "60%"
    },
    attrs: {
      "type": "textarea",
      "maxlength": 300,
      "show-word-limit": ""
    },
    model: {
      value: (_vm.form.description),
      callback: function($$v) {
        _vm.$set(_vm.form, "description", $$v)
      },
      expression: "form.description"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "活动时间"
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "daterange",
      "range-separator": "至",
      "start-placeholder": "开始日期",
      "end-placeholder": "结束日期"
    },
    model: {
      value: (_vm.form.times),
      callback: function($$v) {
        _vm.$set(_vm.form, "times", $$v)
      },
      expression: "form.times"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "状态"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.status),
      callback: function($$v) {
        _vm.$set(_vm.form, "status", $$v)
      },
      expression: "form.status"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("开启")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("关闭")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "满足条件"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n              1. 满足金额 "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "text",
      "maxlength": 5
    },
    model: {
      value: (_vm.form.amount),
      callback: function($$v) {
        _vm.$set(_vm.form, "amount", $$v)
      },
      expression: "form.amount"
    }
  }), _vm._v(" 元\n            ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_vm._v("\n              2. 满足 "), _c('el-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "maxlength": 5
    },
    model: {
      value: (_vm.form.number),
      callback: function($$v) {
        _vm.$set(_vm.form, "number", _vm._n($$v))
      },
      expression: "form.number"
    }
  }), _vm._v(" 件\n            ")], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 4
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.form.is_full),
      callback: function($$v) {
        _vm.$set(_vm.form, "is_full", $$v)
      },
      expression: "form.is_full"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("二选一")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("全部满足")])], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "送券类型"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeType
    },
    model: {
      value: (_vm.form.use_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "use_type", $$v)
      },
      expression: "form.use_type"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "card"
    }
  }, [_vm._v("满减送券")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "offlinecard"
    }
  }, [_vm._v("送线下券")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "package"
    }
  }, [_vm._v("组合券包")])], 1)], 1), _vm._v(" "), (_vm.form.use_type == 'card') ? _c('el-card', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.showCoupons
    }
  }, [_vm._v("选择优惠券+")])], 1), _vm._v(" "), (_vm.form.cardinfo.length > 0) ? _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.form.cardinfo), function(item, index) {
    return _c('div', {
      key: item.id
    }, [_c('el-tag', {
      attrs: {
        "closable": "",
        "type": "success"
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(item)
        }
      }
    }, [_vm._v("\n                    ID:" + _vm._s(item.id) + " : " + _vm._s(item.title) + "\n                ")]), _vm._v("\n                发券数量: "), _c('el-input', {
      staticStyle: {
        "width": "65px"
      },
      attrs: {
        "type": "text",
        "size": "mini"
      },
      model: {
        value: (_vm.form.cardinfo[index].num),
        callback: function($$v) {
          _vm.$set(_vm.form.cardinfo[index], "num", $$v)
        },
        expression: "form.cardinfo[index].num"
      }
    })], 1)
  }), 0) : _vm._e()]) : (_vm.form.use_type == 'offlinecard') ? _c('el-card', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    attrs: {
      "size": "mini",
      "type": "primary"
    },
    on: {
      "click": _vm.addRule
    }
  }, [_vm._v("添加线下券")])], 1), _vm._v(" "), (_vm.form.cardinfo.length > 0) ? _c('div', {
    staticClass: "text item"
  }, _vm._l((_vm.form.cardinfo), function(item, index) {
    return _c('div', {
      key: item.keys,
      staticStyle: {
        "margin": "15px 0"
      }
    }, [_vm._v("\n                线下券编码: "), _c('el-input', {
      staticStyle: {
        "width": "165px"
      },
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.form.cardinfo[index].id),
        callback: function($$v) {
          _vm.$set(_vm.form.cardinfo[index], "id", $$v)
        },
        expression: "form.cardinfo[index].id"
      }
    }), _vm._v("\n                优惠券名称: "), _c('el-input', {
      staticStyle: {
        "width": "285px"
      },
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.form.cardinfo[index].title),
        callback: function($$v) {
          _vm.$set(_vm.form.cardinfo[index], "title", $$v)
        },
        expression: "form.cardinfo[index].title"
      }
    }), _vm._v("\n                发券数量: "), _c('el-input', {
      staticStyle: {
        "width": "65px"
      },
      attrs: {
        "type": "text"
      },
      model: {
        value: (_vm.form.cardinfo[index].num),
        callback: function($$v) {
          _vm.$set(_vm.form.cardinfo[index], "num", $$v)
        },
        expression: "form.cardinfo[index].num"
      }
    }), _vm._v(" "), _c('el-button', {
      attrs: {
        "type": "danger"
      },
      on: {
        "click": function($event) {
          return _vm.handleClose(item)
        }
      }
    }, [_vm._v("删除")])], 1)
  }), 0) : _vm._e()]) : _c('el-form-item', {
    attrs: {
      "label": "组合券包"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.form.send_card_ids),
      callback: function($$v) {
        _vm.$set(_vm.form, "send_card_ids", $$v)
      },
      expression: "form.send_card_ids"
    }
  }, _vm._l((_vm.selectList), function(item) {
    return _c('el-option', {
      key: item.package_num_id,
      attrs: {
        "label": item.package_name,
        "value": item.package_num_id
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "label": "指定商品"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeItems
    },
    model: {
      value: (_vm.form.items_canuse),
      callback: function($$v) {
        _vm.$set(_vm.form, "items_canuse", $$v)
      },
      expression: "form.items_canuse"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部商品")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("指定商品参与")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("指定商品不参与")])], 1)], 1), _vm._v(" "), (_vm.form.items_canuse > 0) ? _c('el-card', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_vm._v("\n                选择商品\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [(!_vm.zdItemHidden) ? _c('SkuSelector', {
    attrs: {
      "data": _vm.relItems
    },
    on: {
      "change": _vm.getItems
    }
  }) : _vm._e()], 1)]) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "指定门店"
    }
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.changeDistributor
    },
    model: {
      value: (_vm.form.distributor_canuse),
      callback: function($$v) {
        _vm.$set(_vm.form, "distributor_canuse", $$v)
      },
      expression: "form.distributor_canuse"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": 0
    }
  }, [_vm._v("全部门店")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 1
    }
  }, [_vm._v("指定门店参与")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": 2
    }
  }, [_vm._v("指定门店不参与")])], 1)], 1), _vm._v(" "), (_vm.form.distributor_canuse > 0) ? _c('el-card', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "mini"
    },
    on: {
      "click": _vm.addDistributorAction
    }
  }, [_vm._v("选择店铺+")])], 1), _vm._v(" "), _c('div', {
    staticClass: "text item"
  }, [(!_vm.zdShopHidden) ? _c('div', [(_vm.distributor_list.length > 0) ? _c('el-table', {
    staticStyle: {
      "line-height": "normal"
    },
    attrs: {
      "data": _vm.distributor_list
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "ID",
      "prop": "distributor_id",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "名称",
      "prop": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "address",
      "label": "地址",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "50"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('i', {
          staticClass: "iconfont icon-trash-alt",
          on: {
            "click": function($event) {
              return _vm.deleteDistritutorRow(scope.$index, _vm.form.items)
            }
          }
        })]
      }
    }], null, false, 3521329561)
  })], 1) : _vm._e()], 1) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.onSubmit
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")])], 1)], 1), _vm._v(" "), _c('couponPicker', {
    attrs: {
      "visible": _vm.couponsVisible
    },
    on: {
      "pickCoupon": _vm.pickCoupon,
      "closeDialog": _vm.closeDialogs
    }
  }), _vm._v(" "), _c('DistributorSelect', {
    attrs: {
      "store-visible": _vm.distributorVisible,
      "is-valid": true,
      "rel-shop-ids": _vm.relDistributorIds,
      "get-status": _vm.setDistributorStatus
    },
    on: {
      "chooseStore": _vm.chooseDistributorAction,
      "closeStoreDialog": _vm.closeDistributorDialogAction
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-658b7d8d", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-658b7d8d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/ordercard/edit.vue
// module id = 2783
// module chunks = 0